import './InteractiveMapFilters.css';
import React from 'react';
import InteractiveMapSearch from './components/InteractiveMapSearch';
import NestedFilters from './components/NestedFilters';
const InteractiveMapFilters = _ref => {
  let {
    params,
    analytics,
    withMapModalView = false,
    mainTitle,
    rtl,
    chosenTypes,
    fields,
    facets,
    defaultFacets,
    facetsStats,
    showLabel,
    resultsLabel,
    nbHits,
    clearAllLabel,
    selectAllLabel,
    setListingFilter,
    resetFilterCallback,
    day,
    days,
    Cancel,
    FiltersCopy,
    isTagPage,
    lang,
    hits,
    dictionary,
    imageDictionary,
    firstQuery,
    resetAllFiltersCallback,
    searchIndex,
    isNestedFilters,
    search,
    requestSettingsForSearch,
    handleAllowSearch,
    allowSearch,
    defaultTypeValues,
    handleResetFiltersFromSearch,
    activeListingItemId,
    handleDisableNestedFiltersFromSearch,
    filterPinsBySearch,
    getActivePopupOnMap,
    activeTopPicks,
    toggleActiveTopPicks
  } = _ref;
  const [searchVisible, toggleSearchVisible] = React.useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles} ${allowSearch ? 'search-mode' : ''} imfilters imfilters-padding`
  }, mainTitle && /*#__PURE__*/React.createElement("h4", {
    className: "imfilter-title "
  }, mainTitle), /*#__PURE__*/React.createElement("div", {
    className: `imfilters-header ${allowSearch ? 'search-mode' : ''}`
  }, /*#__PURE__*/React.createElement(InteractiveMapSearch, {
    analytics: analytics,
    params: params,
    fields: search,
    dictionary: dictionary,
    toggleSearch: () => toggleSearchVisible(!searchVisible),
    handleAllowSearch: handleAllowSearch,
    allowSearch: allowSearch,
    defaultTypeValues: defaultTypeValues,
    handleResetFiltersFromSearch: handleResetFiltersFromSearch,
    activeListingItemId: activeListingItemId,
    handleDisableNestedFiltersFromSearch: handleDisableNestedFiltersFromSearch,
    filterPinsBySearch: filterPinsBySearch,
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: toggleActiveTopPicks,
    hits: hits
  }), /*#__PURE__*/React.createElement("div", {
    className: "imfilters-header-nested-filters "
  }, /*#__PURE__*/React.createElement(NestedFilters, {
    fields: fields,
    params: params,
    facets: facets,
    defaultFacets: defaultFacets,
    facetsStats: facetsStats,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    selectAllLabel: selectAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    day: day,
    days: days,
    Cancel: Cancel,
    FiltersCopy: FiltersCopy,
    isTagPage: isTagPage,
    lang: lang,
    hits: hits,
    dictionary: dictionary,
    imageDictionary: imageDictionary,
    firstQuery: firstQuery,
    analytics: analytics,
    resetAllFiltersCallback: resetAllFiltersCallback,
    searchIndex: searchIndex,
    chosenTypes: chosenTypes,
    withMapModalView: withMapModalView,
    disabled: chosenTypes.length === 0 || chosenTypes.length > 1,
    isNestedFilters: isNestedFilters
  }))));
};
const commonStyles = "cyjm87j";
const ltrStyles = "l1nc4r5d";
const rtlStyles = "r142h99r";
export default InteractiveMapFilters;